export interface NavItem {
  label: string;
  path: string;
  icon: string;
}

export const navItems: NavItem[] = [
  { label: "首页", path: "/", icon: "ri-home-5-line" },
  { label: "全集", path: "/episodes", icon: "ri-play-list-2-line" },
  { label: "角色", path: "/characters", icon: "ri-group-line" },
  { label: "观看指南", path: "/guide", icon: "ri-compass-3-line" },
  { label: "关于", path: "/about", icon: "ri-information-line" },
];

export const quickEntries: NavItem[] = [
  { label: "全集剧情", path: "/episodes", icon: "ri-film-line" },
  { label: "角色介绍", path: "/characters", icon: "ri-user-star-line" },
  { label: "观看指南", path: "/guide", icon: "ri-compass-3-line" },
  { label: "关于我们", path: "/about", icon: "ri-information-line" },
];